import { Monitor, Moon, Sun } from "lucide-react";

const OPTIONS = [
  { value: "light", label: "Light", Icon: Sun },
  { value: "system", label: "System", Icon: Monitor },
  { value: "dark", label: "Dark", Icon: Moon },
];

export const ThemeToggle = ({ mode, setMode }) => (
  <div
    className="flex items-center gap-1 p-1 rounded-full border border-[var(--tg-border)] bg-[var(--tg-surface)] shrink-0"
    role="group"
    aria-label="Colour theme"
    data-testid="theme-toggle"
  >
    {OPTIONS.map(({ value, label, Icon }) => {
      const active = mode === value;
      return (
        <button
          key={value}
          type="button"
          onClick={() => setMode(value)}
          aria-pressed={active}
          title={`${label} theme`}
          data-testid={`theme-${value}`}
          className={`h-9 w-9 grid place-items-center rounded-full transition-colors ${
            active
              ? "bg-[rgb(var(--c-sky-rgb)/0.15)] text-[var(--c-sky)]"
              : "text-[var(--tg-faint)] hover:text-[var(--tg-ink)] hover:bg-[var(--tg-hover)]"
          }`}
        >
          <Icon className="h-4 w-4" />
          <span className="sr-only">{label}</span>
        </button>
      );
    })}
  </div>
);
